const api =
  "/pacientes.php";

export default api;
